<script setup lang="ts">
import RelationView from '@desktop/views/Relation/components/RelationView/RelationView.vue'
import {
  initSportConfiguration,
  provideAsideConfig,
} from '@desktop/views/Relation/Sports/provide-inject'

import RugbyUnionRelation from './components/RelationView/RugbyUnionRelation.vue'
import RugbyUnionStatistics from './components/RelationView/RugbyUnionStatistics.vue'
import {
  addIncidentConfig,
  asideConfig,
  assignIncidentOnPitchConfig,
  customIncidentNames,
  eventInfoControls,
  eventRelatedStatusConfig,
  eventStatuses,
  eventStatusIncidentsOnFieldConfig,
  extraTimeDetailId,
  fieldClickCoordinatesIncidentConfig,
  getEventClockSeconds,
  getEventClockTime,
  getEventPeriodStartOffsetMinutes,
  getEventStatusPeriodLengthMinutes,
  historyFiltersConfig,
  historyIncidentsConfig,
  incidentsQueuePayloadConfig,
  incidentsRequireConfirmation,
  incidentsRequirePointingPositionConfig,
  incidentsResultConfig,
  isValidEventClockTime,
  lastIncidentsConfig,
  lineupConfig,
  manualAddIncidentConfig,
  pitchBlockedEventStatus,
  pitchIncidentsConfig,
  pitchOverlaySupportedStatuses,
  pitchPenaltyOverlayConfig,
  pocketIncidentsConfig,
} from './configuration'

initSportConfiguration({
  addIncidentConfig,
  clock: {
    getEventClockSeconds,
    getEventClockTime,
    getEventPeriodStartOffsetMinutes,
    getEventStatusPeriodLengthMinutes,
    isValidEventClockTime,
    minutesMaxDigits: 3,
    extraTimeDetailId,
  },
  customIncidentNames,
  eventInfoControls,
  eventStatuses,
  eventRelatedStatusConfig,
  hasChangeSides: true,
  historyFiltersConfig,
  incidentsResultConfig,
  incidentsQueuePayloadConfig,
  incidentsRequireConfirmation,
  historyIncidentsConfig,
  manualAddIncidentConfig,
  lastIncidentsConfig,
  lineupConfig,
  verifyResultSummaryConfig: {
    isDrawPossible: true,
  },
  pocketIncidentsConfig,
  pitch: {
    assignIncidentOnPitchConfig,
    eventStatusIncidentsOnFieldConfig,
    fieldClickCoordinatesIncidentConfig,
    incidentsRequirePointingPositionConfig,
    pitchBlockedEventStatus,
    pitchIncidentsConfig,
    pitchOverlaySupportedStatuses,
    pitchPenaltyOverlayConfig,
  },
})

// custom provide-inject for rugby-union until widgets implementation is done
provideAsideConfig(asideConfig)
</script>

<template>
  <RelationView
    :relation="RugbyUnionRelation"
    :statistics="RugbyUnionStatistics"
  />
</template>
